import TheFixitNoHeader from './src/TheFixitNoHeader.vue';
import TheFixitNoSnackbar from './src/TheFixitNoSnackbar.vue';
import ChooseSalonDialog from './src/components/Common/CommonComponents'


export { TheFixitNoHeader, TheFixitNoSnackbar, ChooseSalonDialog }
